import api from 'api';

export const SYSCO_PRODUCTS_ASYNC_ACTION_START = 'SYSCO_PRODUCTS_ASYNC_ACTION_START';
export const SYSCO_PRODUCTS_ASYNC_ACTION_ERROR = 'SYSCO_PRODUCTS_ASYNC_ACTION_ERROR';
export const SYSCO_PRODUCTS_ASYNC_ACTION_SUCCESS = 'SYSCO_PRODUCTS_ASYNC_ACTION_SUCCESS';
export const SYSCO_PRODUCTS_RESET_STATE = 'SYSCO_PRODUCTS_RESET_STATE';
export const SYSCO_PRODUCT_REMOVE = 'SYSCO_PRODUCT_REMOVE';
export const SYSCO_PRODUCTS_REMOVE_RECIPE_PRODUCTS = 'SYSCO_PRODUCTS_REMOVE_RECIPE_PRODUCTS';

function syscoProductsAsyncActionStart() {
  return {
    type: SYSCO_PRODUCTS_ASYNC_ACTION_START,
  };
}

function syscoProductsAsyncActionError(error) {
  return {
    type: SYSCO_PRODUCTS_ASYNC_ACTION_ERROR,
    error,
  };
}

function syscoProductsAsyncActionSuccess(data) {
  return {
    type: SYSCO_PRODUCTS_ASYNC_ACTION_SUCCESS,
    data,
  };
}

export function resetSyscoProductsState() {
  return {
    type: SYSCO_PRODUCTS_RESET_STATE,
  };
}

export function getSyscoProducts(brandId, ingredType) {
  return (dispatch, getState) => {
    dispatch(syscoProductsAsyncActionStart());
    return api.request(`ingredient/listByType?brandId=${brandId}&ingredType=${ingredType}`, 'get')
    .then((data) => {
      dispatch(syscoProductsAsyncActionSuccess(data));
      return data;
    })
    .catch((error) => {
      dispatch(syscoProductsAsyncActionError('Unable to get custom ingredients'));
      throw(error);
    });
  };
}

export function removeSyscoProduct(recipeId, removedIngredientSupc) {
  return {
    type: SYSCO_PRODUCT_REMOVE,
    data: { recipeId, removedIngredientSupc }
  };
}

export function removeRecipeSyscoProducts(recipeId) {
  return {
    type: SYSCO_PRODUCTS_REMOVE_RECIPE_PRODUCTS,
    data: { recipeId }
  };
}